import classNames from "classnames";
import { useTimelineCtx } from "../ctx";

export const TimelineHorizontalButtons = () => {
  const {
    moveToNextView,
    moveToPrevView,
    itemsMovedBy,
    totalAmtOfItems,
    itemsInView,
  } = useTimelineCtx();

  if (itemsInView >= totalAmtOfItems) {
    return null;
  }

  const maxIdx = totalAmtOfItems - itemsInView;
  return (
    <>
      <NavigationButton
        position="left"
        isDisabled={itemsMovedBy <= 0}
        onClick={moveToPrevView}
      />
      <NavigationButton
        isDisabled={itemsMovedBy >= maxIdx}
        position="right"
        onClick={moveToNextView}
      />
    </>
  );
};

interface IBtnProps {
  position: "left" | "right";
  onClick: () => void;
  isDisabled: boolean;
}

const NavigationButton = ({ position, onClick, isDisabled }: IBtnProps) => {
  const { isMobile } = useTimelineCtx();

  // Mobile uses Swiper with `cssMode: true` — scrolling is delegated
  // to native CSS scroll-snap on `.swiper-wrapper` (NOT on `.swiper`,
  // which is overflow:hidden). Scroll the wrapper directly by one slide
  // width; scroll-snap clamps to the next slide boundary.
  const handleMobileClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    const wrapper = e.currentTarget
      .closest(".timeline-combo")
      ?.querySelector(".swiper .swiper-wrapper") as HTMLElement | null;
    if (!wrapper) return;
    const slide = wrapper.querySelector<HTMLElement>(".swiper-slide");
    const step = slide?.clientWidth ?? wrapper.clientWidth;
    wrapper.scrollBy({
      left: position === "right" ? step : -step,
      behavior: "smooth",
    });
  };

  return (
    <button
      type="button"
      onClick={isMobile ? handleMobileClick : onClick}
      disabled={!isMobile && isDisabled}
      data-btn-position={position}
      className={classNames({
        "timeline-horizontal-btn": true,
        "grid tw-absolute tw-top-1/2 tw-z-10 -tw-translate-y-1/2 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border-none tw-bg-[transparent] tw-outline-none": true,
        "disabled:tw-cursor-default": true,
        "tw-left-0": position === "left",
        "tw-right-0": position === "right",
        "tw-size-12 tw-text-[24px] disabled:tw-opacity-40": !isMobile,
        "tw-size-8 tw-text-[16px]": isMobile,
      })}
      style={{
        boxShadow:
          "0px 3px 5px rgba(18, 3, 62, 0.1), 0px 0px 1px rgba(18, 3, 62, 0.11)",
      }}
    >
      <div
        className={classNames({
          "tw-absolute tw-inset-0 tw-size-full tw-rounded-full tw-border tw-border-solid tw-border-blue-100 tw-bg-white": true,
          "tw-opacity-30": isMobile,
        })}
      />
      <i
        className={classNames({
          [`ri-arrow-${position}-line`]: true,
          "tw-relative tw-text-blue-500": true,
        })}
      />
    </button>
  );
};
